import { EnumPlacePageSectionKey } from 'util/place/types/placePageTypes';

export const orderedPlacePageSectionKeys = [
  EnumPlacePageSectionKey.PREFERENCES,
  EnumPlacePageSectionKey.ABOUT,
];
export const orderedPlacePageSideSectionKeys = [EnumPlacePageSectionKey.ABOUT];
